import Button from '@mui/material/Button';
import React from "react";
import {useDispatch, connect} from 'react-redux';
import Paper from "@mui/material/Paper";
import AddIcon from '@mui/icons-material/Add';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import Divider from '@mui/material/Divider';

import { setActiveField, updateSld } from '../actions/index';
import { toggleLayerState } from '../actions/index';
import { calculateFieldStats, ColorUtils } from '../utils/helpers'
import { generateSld } from '../utils/style-generator';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import preloaded from '../utils/data.json';


const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

const LayerSelection = (props) => {
    const dispatch = useDispatch();
    let [value, setValue] = React.useState("");
    let [actlayer, setActLayer] = React.useState("allum_project:1334_egesz_grid_sf");

    React.useEffect(()=>{
        props.onChange(value)
        dispatch(setActiveField(value))
    }, [value])

    React.useEffect(()=>{
        if(props.map.activeLayer.includes("kulonb")||props.map.activeLayer.includes("grid")) {
            setValue("val")
            dispatch(toggleLayerState(actlayer))
        }
    }, [actlayer])

    React.useEffect(()=>{
        try{
            if(!props.map.activeLayer.includes("kulonb")&&!props.map.activeLayer.includes("grid")) {
                setValue(props.map.layers[props.map.activeLayer].choloplethFields[0])
            } else {
                setValue("val")
            }
        }catch(e){
            console.log(e);
        }
    }, [props.map.activeLayer])

    const categories = {};
    for (const item of preloaded) {
        if (item.category in categories) {
            categories[item.category].push(item);
        } else {
            categories[item.category] = [item];
        }
    }
    const cat={};
    
    return <div style={{marginTop: 16}}>
        <Typography variant="caption" gutterBottom component="div">
            Thematic maps
        </Typography>

        <div>
        {
            Object.entries(categories).map((entry) => {
                const category = entry[0];
                const itemList = entry[1];

                if(!props.map.activeLayer.includes("kulonb")&&!props.map.activeLayer.includes("grid")) {
                    {itemList.map((item) => (
                        props.map.layers[props.map.activeLayer].choloplethFields.map(cf=>{
                            if(item.name==cf){
                                if (item.category in cat) {
                                    cat[category].push(item);
                                } else {
                                    cat[category] = [item];
                                }
                            }
                        })
                    ))}

                    if(category!=="undefined" && cat[category]!== undefined && cat[category].length>0) {
                        return (
                            <Accordion key={category}>
                            <AccordionSummary>{category}</AccordionSummary>
                            <AccordionDetails>
                            <RadioGroup aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={(e)=>{setValue(e.target.value)}}>

                            {itemList.map((item) => (
                                <span key={item.name}>
                                    {
                                    props.map.layers[props.map.activeLayer].choloplethFields.map(cf=>{
                                        let found=""
                                        if (cf=="val") {
                                            //Ha grid térkép
                                            found = preloaded.find(obj => {
                                                return obj.name === props.map.activeLayer.replace("allum_project:","");
                                            });
                                        } else {
                                            //Ha egyéb térkép
                                            found = preloaded.find(obj => {
                                                return obj.name === cf;
                                            });
                                        }

                                        if (item.name==cf) {
                                            return <div key={cf}>
                                            <Divider />
                                            <FormControlLabel value={cf} style={{marginLeft:0, marginTop:10, marginBottom:10}} control={<Radio size="small" style={{display:'block'}} />} label={found.title} />
                                        </div>
                                        }
                                    })
                                }
                                    
                                </span>
                            ))}

                            </RadioGroup>
                            </AccordionDetails>
                            </Accordion>
                        );
                    }
                } else {
                    // Grid map
                    {itemList.map((item) => (
                        Object.entries(props.map.layers).map(cf=>{
                            if(item.name==cf[1].name){
                                if (item.category in cat) {
                                    cat[category].push(item);
                                } else {
                                    cat[category] = [item];
                                }
                            }
                        })
                    ))}

                    if(category!=="undefined" && cat[category]!== undefined && cat[category].length>0) {
                        return (
                            <Accordion key={category}>
                            <AccordionSummary>{category}</AccordionSummary>
                            <AccordionDetails>
                            <RadioGroup aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={actlayer} onChange={(e)=>{setActLayer(e.target.value)}}>
                            {itemList.map((item) => (
                                <span key={item.name}>
                                    {
                                        Object.entries(props.map.layers).map((entry) => {
                                            if((entry[1].id.includes("kulonb")) || (entry[1].id.includes("grid"))) {
                                                let found=""
                                                found = preloaded.find(obj => {
                                                    return obj.name === entry[1].id.replace("allum_project:","");
                                                });
                        
                                                if (item.name==entry[1].name) {
                                                    return <div key={entry[1].id}>
                                                    <Divider />
                                                    <FormControlLabel value={entry[1].id} style={{marginLeft:0, marginTop:10, marginBottom:10}} control={<Radio size="small" style={{display:'block'}} />} label={found.title} />
                                                    </div>
                                                }

                                            }
                                        })
                                    }
                                </span>
                            ))}
                            </RadioGroup>
                            </AccordionDetails>
                            </Accordion>
                        );
                    }
        
                }
            })
        }
        </div>

    </div>




}

export default connect(mapStateToProps)(LayerSelection)